
export const CellType = {
  RANK: 'rank',
  TEXT: 'text',
  TEXT_SCHOOL_NAME: 'textSchoolName',
  TEXT_CLASS_NAME: 'textClassName',
  TEXT_STUDENT_NAME: 'textStudentName',
  TEXT_CITY: 'textCity',
  TEXT_DISTRICT: 'textDistrict',
  TEXT_MONSTER: 'textMonster',
  NUMBER: 'number',
  PROGRESS: 'progress',
  STARS: 'stars',
  STATUS: 'status',
  PARTICIPANTS: 'participants',
  INSTITUTION_ID: 'institutionId',
  ACTIONS: 'actions',
  RANKING_SCORE: 'rankingScore',
  CLASS_NAME: 'className',
};

